function injectStyle (ssrContext) {
  require("!!../../../../../../../kdAccountGit/kd-account-backend/node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true,\"publicPath\":\"../../\"}!vue-style-loader!css-loader?{\"sourceMap\":true}!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-0f71c369\",\"scoped\":true,\"hasInlineConfig\":false}!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/selector?type=styles&index=0!./ImgPreview.vue")
}
var normalizeComponent = require("!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/component-normalizer")
/* script */
export * from "!!babel-loader!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/selector?type=script&index=0!./ImgPreview.vue"
import __vue_script__ from "!!babel-loader!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/selector?type=script&index=0!./ImgPreview.vue"
/* template */
import __vue_template__ from "!!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-0f71c369\",\"hasScoped\":true,\"transformToRequire\":{\"video\":[\"src\",\"poster\"],\"source\":\"src\",\"img\":\"src\",\"image\":\"xlink:href\"},\"buble\":{\"transforms\":{}}}!../../../../../../../kdAccountGit/kd-account-backend/node_modules/vue-loader/lib/selector?type=template&index=0!./ImgPreview.vue"
/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0f71c369"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __vue_script__,
  __vue_template__,
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

export default Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/ImgPreivewDialog/ImgPreview.vue
// module id = null
// module chunks = 